import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { Icon, Layout, Menu, Tooltip } from 'antd'
import _ from 'lodash'

import './ConfigPage.scss'

const { Content, Sider } = Layout
const MenuItem = Menu.Item

export class ConfigPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedKey: ''
        }
    }

    componentWillMount() {
        const { location } = this.props
        const url = location.pathname

        this.setState({ selectedKey: url })
    }

    componentDidUpdate(prevProps, prevState) {
        const { location } = this.props

        if (prevProps.location.pathname !== location.pathname) {
            const url = location.pathname

            this.setState({ selectedKey: url })
        }
    }

    renderAdminSection() {
        const { userType } = this.props
        if (userType === 'admin')
            return (
                <MenuItem key="/workdesk/config/user-management">
                    <NavLink to="/workdesk/config/user-management" activeClassName="active-link">
                        <span>User Management</span>
                    </NavLink>
                </MenuItem>
            )
    }

    render() {
        const { children } = this.props
        const { selectedKey } = this.state

        return (
            <div className="ConfigPage">
            	<Layout>
            		<Sider width={140}>
            			<Menu selectedKeys={[selectedKey]}>
                            <MenuItem key="/workdesk/config/profile">
                                <NavLink to="/workdesk/config/profile" activeClassName="active-link">
                                    <span>Profile</span>
                                </NavLink>
                            </MenuItem>
                            { this.renderAdminSection() }
            			</Menu>
            		</Sider>
            		<Layout>
            			<Content>
            				{ children }
            			</Content>
            		</Layout>
            	</Layout>
                <NavLink to="/workdesk">
                    <div className="home-btn">
                        <Tooltip placement="top" title="Home">
                                <Icon type="home" />
                        </Tooltip>
                    </div>
                </NavLink>
			</div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
        userType: state.auth.userType
    }
}

export default connect(mapStateToProps)(ConfigPage)


// WEBPACK FOOTER //
// ./src/ConfigPage/ConfigPage.js